// 车船
const CarShip = () => import('@/components/CarShip')
// 新车
const NewCarIndex = () => import('@/components/carship/NewCarIndex')
const NewCarDetail = () => import('@/components/carship/NewCarDetail')
const ErCarIndex = () => import('@/components/carship/ErCarIndex')
const ErCarDetail = () => import('@/components/carship/ErCarDetail')
const ZuCarIndex = () => import('@/components/carship/ZuCarIndex')
const ZuCarDetail = () => import('@/components/carship/ZuCarDetail')
const NewShipIndex = () => import('@/components/carship/NewShipIndex')
const NewShipDetail = () => import('@/components/carship/NewShipDetail')
const ErShipIndex = () => import('@/components/carship/ErShipIndex')
const ErShipDetail = () => import('@/components/carship/ErShipDetail')
const ZuShipIndex = () => import('@/components/carship/ZuShipIndex')
const ZuShipDetail = () => import('@/components/carship/ZuShipDetail')

export default {
  path: '/carship',
  name: 'Carship',
  component: CarShip,
  meta: {
    title: '万知车船 - 新车 二手车 出租车 新船 二手船 出租船 信息和需求 - 万知',
    Description:'万知车船，是万知网上平台中的一个车船信息板块。用户可以通过  万知车船.com 这个中文网址访问到网上站点。有新车信息、二手车信息、出租车信息、新船信息、二手船信息、出租船信息需求的客户，都可以在万知车船产注册、登录，在这里发布各类相关的车市信息和用车需求。直观明了，类目清晰，操作简单，使用方便。',
    keywords:'新车 二手车 出租车 新船 二手船 出租船 '
  },
  redirect: '/carship/newcar/',
  children: [
    {
      path: '/carship/newcar/',
      name: 'NewCar',
      redirect: '/carship/newcar/index/info',
      meta: {
        title: '万知车船 - 新车 二手车 出租车 新船 二手船 出租船 信息和需求 - 万知',
        Description:'万知车船，是万知网上平台中的一个车船信息板块。用户可以通过  万知车船.com 这个中文网址访问到网上站点。有新车信息、二手车信息、出租车信息、新船信息、二手船信息、出租船信息需求的客户，都可以在万知车船产注册、登录，在这里发布各类相关的车市信息和用车需求。直观明了，类目清晰，操作简单，使用方便。',
        keywords:'新车 二手车 出租车 新船 二手船 出租船 '
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/newcar/index/:tab',
          name: 'NewCarIndex',
          meta: {
            title: '万知车船 - 新车 - 万知',
            Description:'展示新车各项信息',
            keywords:'新车 '
          },
          component: NewCarIndex
        },
        {
          path: '/carship/newcar/detail/:tab/:id',
          name: 'NewCarDetail',
          meta: {
            title: '新车详情 - 万知车船 - 万知',
            description:'介绍新车详细信息包括车辆配置卖家信息车辆图片',
            keywords:'新车详细信息',
          },
          component: NewCarDetail
        }
      ]
    },
    {
      path: '/carship/ercar/',
      name: 'ErCar',
      redirect: '/carship/ercar/index/info',
      meta: {
        title: '万知车船'
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/ercar/index/:tab',
          name: 'ErCarIndex',
          meta: {
            title: '万知车船 - 二手车 - 万知',
            Description:'展示二手车各项信息',
            keywords:'二手车 '
          },
          component: ErCarIndex
        },
        {
          path: '/carship/ercar/detail/:tab/:id',
          name: 'ErCarDetail',
          meta: {
            title: '二手车详情 - 万知车船 - 万知',
            description:'介绍二手车详细信息包括车辆配置卖家信息车辆图片',
            keywords:'二手车详细信息',
          },
          component: ErCarDetail
        }
      ]
    },
    {
      path: '/carship/zucar/',
      name: 'ZuCar',
      meta: {
        title: '万知车船 -出租车 - 万知',
        Description:'展示出租车各项信息',
        keywords:'出租车 '
      },
      redirect: '/carship/zucar/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/zucar/index/:tab',
          name: 'ZuCarIndex',
          meta: {
            title: '万知车船 -出租车 - 万知',
            Description:'展示出租车各项信息',
            keywords:'出租车 '
          },
          component: ZuCarIndex
        },
        {
          path: '/carship/zucar/detail/:tab/:id',
          name: 'ZuCarDetail',
          meta: {
            title: '出租车详情 - 万知车船 - 万知',
            description:'介绍出租车详细信息包括车辆配置卖家信息车辆图片',
            keywords:'出租车详细信息',
          },
          component: ZuCarDetail
        }
      ]
    },
    {
      path: '/carship/newship/',
      name: 'NewShip',
      meta: {
        title: '万知车船 -新船 - 万知',
        Description:'展示新船各项信息',
        keywords:'新船 '
      },
      redirect: '/carship/newship/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/newship/index/:tab',
          name: 'NewShipIndex',
          meta: {
            title: '万知车船 -新船 - 万知',
            Description:'展示新船各项信息',
            keywords:'新船 '
          },
          component: NewShipIndex
        },
        {
          path: '/carship/newship/detail/:tab/:id',
          name: 'NewShipDetail',
          meta: {
            title: '新船详情 - 万知车船 - 万知',
            Description:'展示新船各项信息',
            keywords:'新船 '
          },
          component: NewShipDetail
        }
      ]
    },
    {
      path: '/carship/ership/',
      name: 'ErShip',
      meta: {
        title: '万知车船 -二手船 - 万知',
        Description:'展示二手船各项信息',
        keywords:'二手船 '
      },
      redirect: '/carship/ership/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/ership/index/:tab',
          name: 'ErShipIndex',
          meta: {
            title: '万知车船 -二手船 - 万知',
            Description:'展示二手船各项信息',
            keywords:'二手船 '
          },
          component: ErShipIndex
        },
        {
          path: '/carship/ership/detail/:tab/:id',
          name: 'ErShipDetail',
          meta: {
            title: '二手船详情 - 万知车船 - 万知',
            Description:'展示二手船各项信息',
            keywords:'二手船'
          },
          component: ErShipDetail
        }
      ]
    },
    {
      path: '/carship/zuship/',
      name: 'ZuShip',
      redirect: '/carship/zuship/index/info',
      meta: {
        title: '万知车船 -出租船 - 万知',
        Description:'展示出租船各项信息',
        keywords:'出租船 '
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/zuship/index/:tab',
          name: 'ZuShipIndex',
          meta: {
            title: '万知车船 -出租船 - 万知',
            Description:'展示出租船各项信息',
            keywords:'出租船 '
          },
          component: ZuShipIndex
        },
        {
          path: '/carship/zuship/detail/:tab/:id',
          name: 'ZuShipDetail',
          meta: {
            title: '出租船详情 - 万知车船 - 万知',
            Description:'展示出租船各项信息',
            keywords:'出租船'
          },
          component: ZuShipDetail
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/carship.js